// React
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Libraries
import Joi from "joi";
import PropTypes from "prop-types";
import { Form, Button } from "semantic-ui-react";
import { isEmpty } from "lodash";

// Redux
import { connect } from "react-redux";
import { forgotPassword } from "@Actions/authentication";

// Components
import Text from "@Components/Text";
import Input from "@Components/Input";

// Utils
import { getValidationErrors } from "@Utils/functionality";
import { buildAuthPath } from "@Utils";

// Styles
import styles from "./styles.module.css";

const ForgotPassword = ({ dispatch }) => {
	const navigate = useNavigate();
	const { companyName = "", token = "" } = useParams();
	const defaultErrors = { userName: "" };
	const [userName, setUserName] = useState("");
	const [errors, setErrors] = useState(defaultErrors);
	const schema = Joi.object().keys({
		userName: Joi.string().min(6).required().messages({
			"string.min": "Usuario debe tener mínimo 6 caracteres",
			"string.empty": "Usuario es un campo requerido",
		}),
	});

	const cleanupForm = () => {
		setUserName("");
		setErrors(defaultErrors);
	};

	const handleInput = (e) => {
		const { value, name } = e.target;
		setErrors(defaultErrors);
		switch (name) {
			case "userName":
				setUserName(value);
				break;
			default:
				break;
		}
	};

	const handleForgotPassword = () => {
		const validation = schema.validate({ userName }, { abortEarly: false });
		if (validation.error) {
			setErrors(getValidationErrors(validation, defaultErrors));
		} else {
			dispatch(forgotPassword(userName, cleanupForm, navigate));
		}
	};

	return (
		<>
			<Text className={styles.infoTitle}>
				Ingrese su nombre de usuario, email o teléfono que utilizó para registrarse. Le enviaremos un email con un link para reestablecer su
				contraseña ó solicite un PIN a su administrador.
			</Text>
			<Form>
				<Input
					className={styles.input}
					icon="user"
					label="Usuario"
					required
					error={!isEmpty(errors.userName) && { content: errors.userName, pointing: "above" }}
					placeholder="Nombre de usuario, email, teléfono o PIN."
					name="userName"
					value={userName}
					onChange={handleInput}
					onKeyPress={handleForgotPassword}
				/>
			</Form>
			<Button className={styles.button} fluid onClick={handleForgotPassword}>
				Envíar
			</Button>
			<Text
				className={styles.titleLink}
				onClick={() => {
					return navigate(buildAuthPath("/auth/login", companyName, token), { replace: true });
				}}>
				Cancelar
			</Text>
		</>
	);
};

ForgotPassword.propTypes = {
	dispatch: PropTypes.func,
};

export default connect()(ForgotPassword);
